import { render } from "./App.vue?vue&type=template&id=ca57b9f6"
const script = {}

import "@/styles/index.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__